import dataTestids from '../constants/test-ids';
import YouTubeSVG from '../svg/YouTube';
import CircleButton from './CircleButton';

const YouTubeButton = () => {
  return (
    <a
      href='https://www.youtube.com/channel/UCIEl05oz3KyHZNlpDjiNlPg'
      data-testid={dataTestids.LAYOUT.FOOTER.YOUTUBE}
      target='_blank'
      rel='noreferrer'
    >
      <CircleButton>
        <div className='w-5 h-5'>
          <YouTubeSVG />
        </div>
      </CircleButton>
    </a>
  );
};

export default YouTubeButton;
